export const experienceData = [
  {
    id: 1,
    company: 'MAQ Software',
    jobtitle: 'Software Engineer-1',
    startYear: 'Nov 2023',
    endYear: 'Present',
    desc: 'Used technologies like ReactJS, Azure Synapse and SQL, Azure DevOps for meeting everyday requirements and completing tasks.',
  },
  {
    id: 1,
    company: 'Zeronity Technology Pvt. Ltd.',
    jobtitle: 'Website Developer Intern',
    startYear: 'Feb 2021',
    endYear: 'April 2021',
    desc: ' Worked on Merge conflict checker and resolver in backend using Django and frontend features like comment threading, story-bar.',
  },
];
